import { render, staticRenderFns } from "./goodsRanking.vue?vue&type=template&id=1e0ec025&scoped=true&"
import script from "./goodsRanking.vue?vue&type=script&lang=js&"
export * from "./goodsRanking.vue?vue&type=script&lang=js&"
import style0 from "./goodsRanking.vue?vue&type=style&index=0&id=1e0ec025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ec025",
  null
  
)

export default component.exports